import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import './TrainingPages.css';

const POLLEN_BEE_IMG = "https://customer-assets.emergentagent.com/job_bee-booking/artifacts/k8zgjyqb_Pollen%20-%20bHyyve%20Mascot.png";

const SkillAssessments = () => {
  const navigate = useNavigate();

  return (
    <div className="training-page">
      {/* Banner */}
      <div className="training-banner">
        <div className="banner-content">
          <h1>Skill Assessments</h1>
          <p>Test your knowledge and identify areas for improvement</p>
        </div>
        <img src={POLLEN_BEE_IMG} alt="Pollen" className="banner-bee" />
      </div>

      {/* Empty State */}
      <div className="empty-state">
        <div className="empty-icon">
          <CheckCircle size={64} />
        </div>
        <h2>Assessments Coming Soon</h2>
        <p>Skill assessment tests are being created to help you measure and improve your expertise. Check back soon!</p>
        <Button 
          className="back-btn"
          onClick={() => navigate('/yourhyyve')}
        >
          <ArrowLeft size={18} />
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default SkillAssessments;
